import React, { useState, useRef, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { LocalizationContext } from '../App';

import { useMediaQuery } from 'react-responsive';
import uuid from 'react-uuid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { ReactSession } from 'react-client-session';
import { MapContainer, TileLayer, Marker, Popup, Circle, Polygon } from 'react-leaflet';
import { ThemeProvider, useTheme, createTheme } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const LoupeActivitySecondaryDetails = props => {

    const theme = useTheme();

    const currentActivity = props.currentActivity;
    const language = props.language;
    const activityCode = props.activityCode;
    
    const isMobileView = useMediaQuery({
        query: '(max-width: 900px)'
    });
    
    const mapRef = useRef();
    const [ mapTheme, setMapTheme ] = useState(theme.palette.mode);
    const [ mapCenter, setMapCenter ] = useState([0,0]);
    const [ mapZoon, setMapZoom ] = useState(2);
    const [ fencePosition, setFencePosition ] = useState("");
    
    const fillOptions = { color : "#e3165b" }
    
    const darkThemeUri = "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png";
    const lightThemeUri = "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png";
    const mapuri = (theme.palette.mode == 'dark' ? darkThemeUri : lightThemeUri);


    useEffect(() => {

        // make request
        let uri = process.env.REACT_APP_SERVICE_URI + '/api/getActivityDetails/' + currentActivity.activityLanguage + '/' + activityCode;
        

        axios.get(uri, {
            withCredentials:true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                'LOUPE-USR-KEY' : ReactSession.get("userid"),
                'LOUPE-API-KEY' : 'APIKEY2',
            }
        }).then(res => { 
            
            setMapCenter([currentActivity.latitude, currentActivity.longitude]);
            mapRef.current.setView( [currentActivity.latitude, currentActivity.longitude] , 13);
            
            var polys = [];
            res.data.map(f => {
                var coords = [];
                var geojs = f.Geometry;

                geojs = geojs.replace('POLYGON((', '').replace('))', '').split(',');
                geojs.map(ps => {
                    var c = ps.split(' ');
                    coords.push( [ parseFloat(c[1]), parseFloat(c[0]) ] );
                })

                polys.push(coords);
            });

            setFencePosition(polys);


        }).catch(error => {
            console.log(error);
        });

    }, []); 

    
    return (

        <LocalizationContext.Consumer> 
            { ({strings}) => 
        
        <div>

            <Card className="mb-2" raised={false} elevation={0}>
                <CardContent>
                    <Typography color="text.secondary" variant="subtitle1" className="fw-lighter text-start">{strings.getString("texts.details.contact")}</Typography>  
                    <Typography variant="body2" className="text-start">{currentActivity.PointOfContact}</Typography>               
                </CardContent>
            </Card>             

            <Divider />

            <Card className="mb-2" raised={false} elevation={0}>
                <CardContent>
                    <Typography color="text.secondary" variant="subtitle1" className="fw-lighter text-start">{strings.getString("texts.details.keywords")}</Typography>  
                    <Typography variant="body2" className="text-start">{currentActivity.Keywords}</Typography>               
                </CardContent>
            </Card>  

            <Divider />     

            <Card className="mb-2" raised={false} elevation={0}>
                <CardContent>
                <Typography color="text.secondary" variant="subtitle1" className="fw-lighter text-start">{strings.getString("texts.details.area")}</Typography>                              
                    

                    <MapContainer
                        whenCreated={mapInstance => {mapRef.current = mapInstance}}
                        center={mapCenter} 
                        zoom={mapZoon}
                        zoomControl={false} 
                        dragging={false}
                        touchZoom={false}                                
                        scrollWheelZoom={false}
                        className="smallMap" >

                            <TileLayer
                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />

                        { fencePosition != "" && 
                            fencePosition.map(p => {
                                return(
                                    <Polygon key={uuid()} positions={p} pathOptions={fillOptions}/>
                                );

                            })                                                                                
                            } 

                    </MapContainer>
                </CardContent>
            </Card>   
        </div>

        }
        </LocalizationContext.Consumer>                                 

    );

}
export default LoupeActivitySecondaryDetails;